import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'redux-form';
import { toIdString } from '../../utils/common';
import { getClassName, checkButtonDisabled } from '../../utils/forms';
import InputField from '../shared/InputField';

export default class UserInviteForm extends React.Component {
  static propTypes = {
    closeFunction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    submitFunction: PropTypes.func.isRequired,
    userTypes: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit = params => {
    const { submitFunction } = this.props;
    submitFunction(params);
  };

  renderCheckbox = ({ input, type, label, meta: { touched, error } }) => (
    <div className={getClassName(touched, error)}>
      <label htmlFor={toIdString(label)} className="form-control-label">
        {label} {touched && error && <span className="error">| {error}</span>}
      </label>
      <br />
      <input {...input} id={toIdString(label)} type={type} />
    </div>
  );

  renderUserTypes = userType => (
    <option key={userType.id} value={userType.id}>
      {userType.description}
    </option>
  );

  renderSelect = ({ input, label, meta: { touched, error } }) => {
    const { userTypes } = this.props;
    return (
      <div className={getClassName(touched, error)}>
        <label htmlFor={toIdString(label)} className="form-control-label">
          {label} {touched && error && <span className="error">| {error}</span>}
        </label>
        <select {...input} id={toIdString(label)} className="form-control">
          <option>-------</option>
          {userTypes.size === 0 ? null : userTypes.valueSeq().map(this.renderUserTypes)}
        </select>
      </div>
    );
  };

  render() {
    const { handleSubmit, invalid, isSuperAdmin, submitting, closeFunction } = this.props;

    return (
      <div className="container">
        <fieldset>
          <Form id="userInviteForm" onSubmit={handleSubmit(this.submit)}>
            <div className="form-group row">
              <div className="col-md-6">
                <Field
                  name="firstName"
                  component={InputField}
                  type="text"
                  label="First Name"
                  autoFocus
                />
              </div>
              <div className="col-md-6">
                <Field name="lastName" component={InputField} type="text" label="Last Name" />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-md-6">
                <Field name="newUserEmail" component={InputField} type="email" label="Email" />
              </div>
              <div className="col-md-6">
                <Field
                  name="phoneNumber"
                  component={InputField}
                  type="text"
                  label="Phone Number"
                  placeholder="(   ) ___ - ____ ext ___"
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-md-6">
                <Field name="accessLevel" component={this.renderSelect} label="Access Level" />
              </div>
              {isSuperAdmin ? (
                <div className="col-md-6">
                  <Field
                    name="isPrimary"
                    component={this.renderCheckbox}
                    type="checkbox"
                    label="Set As Primary?"
                  />
                </div>
              ) : null}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-link"
                data-dismiss="modal"
                onClick={closeFunction}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={checkButtonDisabled(invalid, submitting)}
              >
                Invite User
              </button>
            </div>
          </Form>
        </fieldset>
      </div>
    );
  }
}
